export const DEFAULT_ARROW_MARK_STYLE = {
  cornerRadius: 4,
  stroke: 'black',
  strokeOpacity: 1,
  lineWidth: 1,
  closePath: false,
  pickable: false
};

export const DEFAULT_ARROW_SYMBOL_MARK_STYLE = {
  symbolType: 'triangle',
  size: 8,
  scaleX: 0.7,
  fill: 'black'
};

export const DEFAULT_ARROW_TEXT_MARK_STYLE = {
  fill: '#606773',
  fontSize: 12
};

export const DEFAULT_FUNNEL_BACKGROUND_MARK_STYLE = {
  fill: '#eff1f9'
};
